"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationStatusFragment = exports.applicationStatusFlatFields = void 0;
exports.applicationStatusFlatFields = `
  accountNumber
  caseNumber
  correlationId
  customerInformationResponseStatus
  enovaGrant
  r35Status
  resultCode
`;
exports.applicationStatusFragment = `
  fragment application on ApplicationStatus {
    ${exports.applicationStatusFlatFields}
    agreement {
      applicableForApplicantType
      code
      description
      financingType
      objectGroups {
        code
        name
      }
    }
    calculation {
      administrationFee
      creditCost
      downPayment
      downPaymentPercentage
      duration
      effectiveInterest
      extraEquipmentSubjectToVat
      extraFeeMonthly
      financedAmount
      ignoreCampaigns
      invoiceFee
      monthlyCostServices
      nominalInterest
      price
      registrationFee
      residualValue
      residualValuePercentage
      serviceAgreementPerYearFee
      tireHotelPerYearFee
      totalCost
      totalMonthlyCost
      totalMonthlyCostIncludingServices
      totalPeriodicAmount
      totalPeriodicAmountVat
    }
    coSigner {
      contacts {
        email
        mobilePhone
      }
      firstName
      lastName
    }
    objectRegistry {
      chassisNumber
      initialMileage
      isDirectImport
      isNew
      make
      model
      pricePerAdditionalMile
      registrationNumber
      registrationYear
      yearlyMileage
    }
    primary {
      contacts {
        email
        mobilePhone
      }
      firstName
      lastName
    }
    salesPerson {
      fullName
      id
      username
    }
  }
`;
//# sourceMappingURL=application-status.js.map